<script setup lang="ts">
import StatusTag from '@taler/ui/StatusTag.vue'

interface ToastItem {
  readonly id: number
  readonly tone: 'ok' | 'danger' | 'neutral'
  readonly message: string
}

/** Bottom-right stack of outcome messages; a danger toast waits for dismissal, the rest are timed out by the caller. */
defineProps<{ toasts: readonly ToastItem[]; dismissLabel: string }>()
const emit = defineEmits<{ dismiss: [id: number] }>()
</script>

<template>
  <div
    class="pointer-events-none fixed bottom-[var(--space-group)] right-[var(--space-group)] z-[60] flex flex-col items-end gap-[var(--space-inline)]"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :role="toast.tone === 'danger' ? 'alert' : 'status'"
      class="pointer-events-auto flex max-w-[24rem] items-center gap-[var(--space-inline)] rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] py-[var(--space-inline)] pl-[var(--space-cell)] pr-[var(--space-inline)] shadow-[var(--shadow-overlay)] animate-toast-in motion-reduce:animate-none"
    >
      <StatusTag :tone="toast.tone" size="md">{{ toast.message }}</StatusTag>
      <button
        type="button"
        :aria-label="dismissLabel"
        class="flex h-[var(--density-target-min)] w-[var(--density-target-min)] shrink-0 items-center justify-center rounded-[var(--radius-control)] text-[color:var(--color-text-muted)] transition-colors duration-[var(--motion-fast)] hover:bg-[color:var(--color-surface-sunken)] hover:text-[color:var(--color-text)]"
        @click="emit('dismiss', toast.id)"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          aria-hidden="true"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
        >
          <path d="M2.5 2.5l7 7M9.5 2.5l-7 7" />
        </svg>
      </button>
    </div>
  </div>
</template>
